/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

import af_ZA from './af-ZA';
import ar_AE from './ar-AE';
import ar_EG from './ar-EG';
import ar_JO from './ar-JO';
import ar_MA from './ar-MA';
import ar_SA from './ar-SA';
import de_DE from './de-DE';
import en_GB from './en-GB';
import en_US from './en-US';
import es_ES from './es-ES';
import es_MX from './es-MX';
import fr_CA from './fr-CA';
import fr_FR from './fr-FR';
import it_IT from './it-IT';
import pt_BR from './pt-BR';
import ro_RO from './ro-RO';
import ru_RU from './ru-RU';
import sw_KE from './sw-KE';
import tr_TR from './tr-TR';
import yo_NG from './yo-NG';
import c from '~/utils/constants';
import features from '~/featuresWithDefaults';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: features.i18n.fallbackLng,
    // lng: features.i18n.defaultLng,
    resources: {
      'af-ZA': af_ZA,
      'ar-AE': ar_AE,
      'ar-EG': ar_EG,
      'ar-JO': ar_JO,
      'ar-MA': ar_MA,
      'ar-SA': ar_SA,
      'de-DE': de_DE,
      'en-GB': en_GB,
      'en-US': en_US,
      'es-ES': es_ES,
      'es-MX': es_MX,
      'fr-CA': fr_CA,
      'fr-FR': fr_FR,
      'it-IT': it_IT,
      'pt-BR': pt_BR,
      'ro-RO': ro_RO,
      'ru-RU': ru_RU,
      'sw-KE': sw_KE,
      'tr-TR': tr_TR,
      'yo-NG': yo_NG,
    },
    supportedLngs: features.i18n.userLanguages as any as string[],
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      defaultVariables: {
        brandingName: c.brandingName,
      },
    },
    keySeparator: false, // default: '.'
    react: {
      bindI18n: 'languageChanged', // default: 'languageChanged'
      bindI18nStore: '', // default: ''
      transEmptyNodeValue: '', // default: ''
      transSupportBasicHtmlNodes: true, // default: true
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'bdi'], // default: ['br', 'strong', 'i']
      useSuspense: false, // default: true,
    },
    detection: {
      convertDetectedLanguage: (lng: string) => {
        const langToCheck = lng.toLowerCase();
        const foundLangFromFeatureBestMatch = features.i18n.userLanguages.find(
          (localeWithRegion) => {
            return langToCheck === localeWithRegion.toLowerCase();
          }
        );
        if (foundLangFromFeatureBestMatch) {
          return foundLangFromFeatureBestMatch;
        }
        const foundLangFromFeatureWithoutRegion = features.i18n.userLanguages.find(
          (localeWithRegion) => {
            return langToCheck.split('-')?.[0] === localeWithRegion.toLowerCase().split('-')?.[0];
          }
        );
        return foundLangFromFeatureWithoutRegion || features.i18n.fallbackLng;
      },
    },
    load: 'currentOnly',
  });

export default i18n;
